import { computed, ref } from 'vue'

export function useLoading (initialState = false) {
  const loading = ref<boolean>(initialState)
  const error = ref<boolean>(false)
  const loaded = ref<boolean>(false)

  const isLoading = computed(() => loading.value)
  const isError = computed(() => error.value)
  const isLoaded = computed(() => loaded.value)

  const setLoading = (value: boolean) => {
    loading.value = value
  }
  const setError = (value: boolean) => {
    error.value = value
  }
  const setLoaded = (value: boolean) => {
    loaded.value = value
  }

  return {
    isLoading,
    isError,
    isLoaded,
    setLoading,
    setError,
    setLoaded,
  }
}
